import clx from 'classnames';

import styles from './PrimaryButton.module.scss';

export const PrimaryButton = ({
        border,
        text,
        label,
        leftIconSrc,
        rightIconSrc,
        onClick = () => { },
        className = {},
        style = {},
        type = 'button',
        disabled = false,
        isLoading = false,
        margin = '10px auto',
}) => (
        <button
                style={{
                  margin,
                        border,
                }}
                className={clx(
                        styles.primary__btn,
                        style,
                        className,
                        { [styles.shimmer]: isLoading }
                )}
                onClick={onClick}
                type={type}
                disabled={disabled}
        >
                {leftIconSrc && <img className={styles['left-icon']} src={leftIconSrc} alt='icon' />}
                <span>{text || label }</span>
                {rightIconSrc && <img className={styles['right-icon']} src={rightIconSrc} alt='icon' />}
        </button>
);

export default PrimaryButton;
